<template>
  <v-dialog v-model="dialog" width="500">
    <v-card height="400">
      <v-row
        class="ma-0 back-556C96  color-white height-60 align-center "
        height="60"
      >
        <h3 class="ml-5">QR코드 확인</h3>
      </v-row>
      <v-row class="ma-0 justify-center pt-5 pb-3 ">
        <qr-code :text="qrCode" size="150" color="#000000" />
      </v-row>
      <v-row class="ma-0 pl-3 pt-3 text-center">
        <h3>QR코드 링크 :</h3>
      </v-row>
      <v-row class="ma-0 pl-3 pb-3">
        <a :href="qrCode">{{ qrCode }}</a>
      </v-row>
      <v-row class="ma-0 justify-center pt-3">
        <v-btn
          width="150"
          height="40"
          class="mr-3 color-white"
          v-clipboard:copy="qrCode"
          color="#739EEC"
          >QR링크 복사</v-btn
        >
        <v-btn @click="dialog = false" width="150" height="40" color="#EEEEEE"
          >닫기
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import InvoiceApi from "@/api/InvoiceService";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    "qr-code": VueQRCodeComponent,
  },

  data: function() {
    return {
      dialog: false,
      state: "",
      qrCode: "",
    };
  },

  created: function() {
    this.$bus.$on("qrCodeView", async (value, state) => {
      this.state = state;
      let returnData = await InvoiceApi.invoiceDetail({ invoiceId: value });
      this.qrCode =
        `${window.location.protocol}//${window.location.host}` +
        "/qrCode?qrText=" +
        returnData.data.invoiceDetail.invoiceName;
      this.dialog = true;
    });
  },
};
</script>

<style scoped>
.height-60 {
  height: 60px;
}
</style>
